import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            探索知识分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            从生理基础到实操技巧，从健康益处到安全须知，系统性掌握前列腺健康知识
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group block bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                {cat.description}
              </p>
              <span className="text-xs text-primary-500 font-medium">
                {cat.articleCount} 篇文章
                <i className="ri-arrow-right-line ml-1"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}